import { RootObject } from '../../types/InAppDonationTypes/comcastDonationTypes'
import { TransactionDataPayload } from '../../types/InAppDonationTypes/transactionDonationTypes'

const transaction: RootObject<TransactionDataPayload> = {
  data: {
    type: 'Transaction',
    attributes: {
      token: '',
      amount: null,
      currency: 'usd',
      gateway_type: 'xfinity',
      source_codes: ['xfinity test'],
      pid: '',
      gateway_transaction_request: [],
    },
    relationships: {
      customer: {
        data: {
          type: 'Customer',
          first_name: '',
          last_name: '',
          gateway_customer_id: '',
          email: '',
        },
      },
      payment_campaign: {
        data: {
          id: '',
          type: 'PaymentCampaign',
        },
      },
    },
  },
}

export default transaction
